// 
// -----------------------------------------------------------------------------
(function ($shoppcart) {
	if ($shoppcart.length === 0) {return false;}

	var $slideIt = $('.slide-it');
	var $overlay =  $('.content-overlay');
	var preOutTimer = null;

	function shopSlide(){
		$shoppcart.addClass('preOut');
		$slideIt.addClass('preSlide');
		$overlay .addClass('preOn');

		setTimeout(function(){
			$shoppcart.toggleClass('out');
			$slideIt .toggleClass('slide');
			$overlay .toggleClass('on');
		}, 10);

		preOutTimer = setTimeout(function(){
			$shoppcart.removeClass('preOut');
			$slideIt.removeClass('preSlide');
			$overlay.removeClass('preOn');
		}, 1000);
	}

	$('.shoppcart-toggle').on('click', function(){
		clearTimeout(preOutTimer);
		shopSlide();
	});

	$('.content-overlay').on('click', function(){
		clearTimeout(preOutTimer);
		shopSlide();
	});

	$shoppcart.find('.shoppcart-item-wrap').mCustomScrollbar();

})($( '.shoppcart' ));